import { createFileRoute } from '@tanstack/react-router'
import AuthCallbackPage from '@features/auth/components/AuthCallbackPage'

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallbackPage,
})
